import "@arco-design/web-react/es/Notification/style";
import _Notification from "@arco-design/web-react/es/Notification";
import axios from 'axios';
// const baseURL = '';//
// const baseURL = 'http://localhost:9502'; //
// const baseURL ='http://gugu.mi7soft.top';
const baseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:9502' : '';
function getToken() {
  // 从本地存储或其他地方获取 Token
  return localStorage.getItem('token');
}

// 封装 API 类
class Api {
  constructor() {
    this.axiosInstance = axios.create({
      baseURL: baseURL
    });
    this.getToken = getToken;

    // 添加请求拦截器
    this.axiosInstance.interceptors.request.use(request => {
      const token = this.getToken();
      if (token) {
        request.headers.Token = `${token}`;
      }
      return request;
    }, error => {
      return Promise.reject(error);
    });

    // 添加响应拦截器（可选）
    this.axiosInstance.interceptors.response.use(response => {
      if (response.headers.token) {
        localStorage.setItem('token', response.headers.token);
      }
      return response;
    }, error => {
      // 在这里处理 token 失效的情况，比如重定向到登录页面
      if (error.response?.status === 401) {
        console.error('Unauthorized, redirecting to login...');
        // 例如：window.location.href = '/login';
      }
      return Promise.reject(error);
    });
  }

  // 定义GET请求
  // public get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
  //   return this.axiosInstance.get<T>(url, config).then((response) => response.data);
  // }

  get(url, data, config, loading) {
    if (typeof loading == 'function') {
      loading(true);
    }
    if (config) {
      config['params'] = data;
    } else {
      config = {
        params: data
      };
    }
    const axiosPromise = this.axiosInstance.get(url, config);
    axiosPromise.catch(error => {
      _Notification.error({
        // title: t['login.form.title'], //'错误',
        content: error.toString()
      });
    });
    if (typeof loading == 'function') {
      axiosPromise.finally(() => {
        loading(false);
      });
    }
    return axiosPromise;
  }

  // 定义POST请求
  // Promise<AxiosResponse<T, any>>
  // public post<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
  //   return this.axiosInstance.post<T>(url, data, config).then((response) => response.data);
  // }

  post(url, data, config, loading) {
    if (typeof loading == 'function') {
      loading(true);
    }
    const axiosPromise = this.axiosInstance.post(url, data, config);
    axiosPromise.catch(error => {
      _Notification.error({
        // title: t['login.form.title'], //'错误',
        content: error.toString()
      });
    });
    if (typeof loading == 'function') {
      axiosPromise.finally(() => {
        loading(false);
      });
    }
    return axiosPromise;
  }

  // 其他HTTP方法可以在这里定义，例如：put, delete, patch等

  upload(url, file, config, loading) {
    if (typeof loading == 'function') {
      loading(true);
    }
    // 创建 FormData 对象
    const data = new FormData();
    data.append('file', file);
    const axiosPromise = this.axiosInstance.post(url, data, config);
    axiosPromise.catch(error => {
      _Notification.error({
        // title: t['login.form.title'], //'错误',
        content: error.toString()
      });
    });
    if (typeof loading == 'function') {
      axiosPromise.finally(() => {
        loading(false);
      });
    }
    return axiosPromise;
  }
}
export default new Api();